import { Api } from "./api"

const PATH = 'password-reset-settings'
const ENDPOINTS = {
    Update: 'update',
}

const getSettings = (signal) => {
    return Api.get(`${PATH}`, signal)
}

const updateSettings = (payload, signal) => {
    return Api.post(`${PATH}/${ENDPOINTS.Update}`, payload, signal)
}

export const PasswordResetSettingsApi = {
    getSettings,
    updateSettings,
}
